import React from 'react'

const COPApprovals = () => {
  return (
    <>
        <h4>COP Approval</h4>
    </>
  )
}

export default COPApprovals